import Storefront from '../src/Storefront/index';
export default Storefront;
